<template>
    <v-autocomplete filled outlined dense label="Auditoria" hide-details="auto" :items="db.auditorias"
        :item-text="displayText" item-value="uuid" v-model="plantilla.refUuid" return-object @change="submit">
        <template v-slot:append-outer class="ma-0">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="info darken-1" size="30" @click="generate"
                        style="cursor: pointer">mdi-file-download-outline</v-icon>
                </template>
                <span>Genera formato de ejemplo con la entidad seleccionada y descarga el
                    fichero</span>
            </v-tooltip>
        </template>
    </v-autocomplete>
</template>

<script>
import moment from 'moment'


export default {
    props: {
        plantilla: {
            type: Object,
            default: () => ({})
        },


    },
    data: () => ({
        db: {
            auditorias: []
        }
    }),
    methods: {
        displayText(item) {
            return `Auditoria del ${moment(item.start).format('DD/MM/YYYY')} - ${item.cliente.nombreCompleto
                } (${item.subalcance.nombre})`
        },
        submit() {
            this.$emit('input', this.plantilla)
        },
        generate() {
            this.$emit('generate')
        },

        async getAuditorias() {
            if (!this.plantilla.subalcance) return
            let subalcance_uuid = null
            if (typeof this.plantilla.subalcance == 'object')
                subalcance_uuid = this.plantilla.subalcance.uuid
            else subalcance_uuid = this.plantilla.subalcance
            const xhr = await this.$store.dispatch('auditorias/listBySubalcance', subalcance_uuid)
            this.db.auditorias = xhr
        },

        async init() {
            await this.getAuditorias()
        }
    },

    mounted() {
        this.init()
    }
}
</script>